import React from 'react';
import { Video } from 'lucide-react';
import CctvCameraWidget from './CctvCameraWidget';

// One dedicated CCTV widget per large client (companies with many cameras), each
// scoped to that company's cameras only. These are Andy's personal dashboard
// overview tiles: admin-only AND owner-locked to Andy — no other user, not even
// another admin, sees or uses them. (The team-facing, scope-gated path is the
// in-module CameraSnapshot previews in CCTV/Assets, NOT these widgets.)
//
// To add another client widget: append to CLIENTS with a NEW stable id + the
// company UUID. Reuses CctvCameraWidget via the companyId/label props.
const ANDY_USER_ID = 'eafdff80-02d2-4eef-9e5c-19f57761b85d';

const CLIENTS = [
  { id: 'cctv_camera_europa',      companyId: 'c5b5c476-c4a1-4fce-8ad0-93ee30aa8747', label: 'Cámaras Europa' },
  { id: 'cctv_camera_respirar',    companyId: '05640c93-aace-42be-92bb-69dd44bdfda4', label: 'Cámaras Respirar' },
  { id: 'cctv_camera_recrear',     companyId: '4579c77a-8753-4d81-9547-a79f737a19fe', label: 'Cámaras Centro Re-Crear' },
  { id: 'cctv_camera_hrcaballito', companyId: '5b600123-224c-4623-8e22-5182d3941e88', label: 'Cámaras Hair Recovery Caballito' },
];

function makeClientCameraWidget({ id, companyId, label }) {
  const Component = (props) => (
    <CctvCameraWidget {...props} companyId={companyId} label={label} />
  );
  Component.displayName = id;
  return {
    meta: {
      id,
      category: 'monitoring',
      // Literal label — t() passes unknown keys through unchanged, so it renders
      // the company label in both the widget header and the picker.
      titleKey: label,
      descriptionKey: `${label} — en vivo, sólo Andy.`,
      defaultSize: 'lg',
      icon: Video,
      minRole: 'admin',
      ownerUserId: ANDY_USER_ID,
    },
    Component,
  };
}

export const clientCameraWidgets = CLIENTS.map(makeClientCameraWidget);
